import { api } from '@/scripts/api';
import { error } from 'jquery';

export const SocialMediaPostTemplateService = {

    getAll(config = {}, accountId, signal) {
        return new Promise((resolve, reject) => {
            const service  = `/ms/socialmedia/v1/socialtemplate/${accountId}`;
            const endpoint = api.applyNodeDataParams(service, config);

            api.get(endpoint, signal)
                .then(resolve)
                .catch((error) => {
                    if (!api.isCanceled(error)) {
                        reject(error);
                    }
                })

        });
    },

    get(id, accountId){
        return new Promise((resolve, reject) => {
            const service = `/ms/socialmedia/v1/socialtemplate/${id}/${accountId}`;

            api.get(service)
                .then(resolve)
                .catch(reject);
        })
    },

    getPreview(id, accountId) {
        return new Promise((resolve, reject) => {
            const service = `/ms/socialmedia/v1/socialtemplate/${ id }/preview/${ accountId }`

            api.get(service)
                .then(resolve)
                .catch(reject)
        })
    },

    patchPreview(id, accountId){
        return new Promise((resolve, reject) => {
            const service = `/ms/socialmedia/v1/socialtemplate/previewedCount/${ id }/${ accountId }`

            api.msPatch(service)
                .then(resolve)
                .catch(reject)
        })
    },

    getVendorTemplateMetrics(config, accountId){
        return new Promise((resolve, reject) => {
            const service = `/ms/socialmedia/v1/statistics/templates/overview/${ accountId }`
            const endpoint = api.applyNodeDataParams(service, config);

            api.get(endpoint)
                .then(resolve)
                .catch(reject)
        })
    },

    getVendorTemplateAnalyticsForExport(config, accountId){
        return new Promise((resolve, reject) => {
            const service = `/ms/socialmedia/v1/analytics/templates/pdf/${ accountId }`
            const endpoint = api.applyNodeDataParams(service, config);

            api.get(endpoint)
                .then(resolve)
                .catch(reject)
        })
    },

    post(accountId, payload){
        return new Promise((resolve, reject) => {
            const service = `/ms/socialmedia/v1/socialtemplate/${accountId}`;

            api.post(service, payload)
                .then(resolve)
                .catch(reject);
        })
    },

    postPreviewUrl(payload) {
        return new Promise((resolve, reject) => {
            const service = '/ms/socialmedia/v1/socialpost/get-link-preview';

            api.post(service, payload)
            .then(resolve)
            .catch(reject);
        });
    },

    putImage(url, fileToUpload, config) {
        return new Promise((resolve, reject) => {
            api.putInstance(url, fileToUpload, config)
            .then(resolve)
            .catch(reject);
        });
    },

    patch(id, accountId, payload) {
        return new Promise((resolve, reject) => {
            const service = `/ms/socialmedia/v1/socialtemplate/${id}/${accountId}`;
            
            api.msPatch(service, payload)
                .then(resolve)
                .catch(reject);
        });
    },

    patchPublish(id, accountId){
        return new Promise((resolve, reject) => {
            const service = `/ms/socialmedia/v1/socialtemplate/toggle-is-auto-publish/${id}/${accountId}`;
            
            api.msPatch(service)
                .then(resolve)
                .catch(reject);
        });
    },

    unpublish(id, accountId){
        return new Promise((resolve, reject) => {
            const service = `/ms/socialmedia/v1/socialtemplate/${id}/unpublish/${accountId}`;
            
            api.put(service)
                .then(resolve)
                .catch(reject);
        });
    },

    delete(id, accountId){
        return new Promise((resolve, reject) => {
            const service = `/ms/socialmedia/v1/socialtemplate/${id}/${accountId}`;

            api.delete(service)
                .then(resolve)
                .catch(reject);
        })
    },

    
    duplicate(accountId, payload){
        return new Promise((resolve, reject) => {
            const service = `/ms/socialmedia/v1/socialtemplate/duplicate/${accountId}`;

            api.post(service, payload)
                .then(resolve)
                .catch(reject);
        })
    },

    postBulk(accountId, payload){
        return new Promise((resolve, reject) => {
            const service = `/ms/socialmedia/v1/socialtemplate/bulk-duplicate-media/${accountId}`

            api.post(service, payload)
            .then(resolve)
            .catch(reject);
        })
    },

    getShared(id, accountId){
        return new Promise((resolve, reject) => {
            const service = `/ms/socialmedia/v1/socialtemplate/${id}/template-shares/${accountId}`;

            api.get(service)
                .then(resolve)
                .catch(reject);
        })
    },

    getSharedTemplates(config = {}, accountId) {
        return new Promise((resolve, reject) => {
            const service  = `/ms/socialmedia/v1/socialtemplate/accounts/${accountId}/resources`;
            const endpoint = api.applyNodeDataParams(service, config);

            api.get(endpoint)
                .then(resolve)
                .catch(reject);

        });
    },
}
